import React, { Component } from 'react';

export class V4Disabled extends Component {
    static displayName = 'V4 Disabled';

    render() {
        return (
            <div>
                <h1>V4 Disabled For Account</h1>
                    <p>This account has not yet opted in to the V4 preview. Please use the Trakref Classic link above to return to the old version, or switch to another account.</p>
                </div>
        );
    }
}

export default V4Disabled;
